<template>
  <div class="tw:hidden tw:sm:flex tw:relative tw:w-full tw:mx-auto" :key="selectedAccommodationId">
    <LaunchpadLoader v-if="isLoading" class="tw:w-full tw:flex tw:justify-center tw:items-center tw:flex-1" />
    <div v-else-if="isError" class="tw:flex tw:justify-center tw:items-center tw:flex-1">
      <ErrorModal
        :allow-retry="false"
        :app-name="'Hotel Offers'"
        :use-app-name="true"
        header-key="onboarding.appLaunchError.header"
        content-key="onboarding.appLaunchError.text"
        retry-key="onboarding.appLaunchError.retryButton"
      />
    </div>
    <HotelOffers v-else />
    <FullScreenLoader v-show="isOffersFetching || isAuthFetching" />
  </div>
</template>

<script setup lang="ts">
/**
 * Hotel Offers View
 *
 * Access control (Plus subscription check) handled by route meta:
 *   meta: { requires: { hasStudioPlus: true } }
 */
import { computed, type ComputedRef } from 'vue'

import LaunchpadLoader from '@/components/dashboard/common/LaunchpadLoader.vue'
import FullScreenLoader from '@/components/base/loaders/FullScreenLoader.vue'
import ErrorModal from '@/components/dashboard/ErrorModal.vue'
import HotelOffers from '@/components/hotelOffers/HotelOffers.vue'

import { useStudioPlusAuth } from '@/composables/useStudioPlusAuth'
import { useOffersTemplates } from '@/components/hotelOffers/queries'
import { selectedAccommodationId } from '@/layouts/queries'

// ==================== Queries ====================

const { isFetching: isOffersFetching, isError: isOffersError, isLoading: isOffersLoading } = useOffersTemplates()

const { isAuthLoading, isAuthFetching, isError: isPlusError } = useStudioPlusAuth()

// ==================== Computed ====================

/** Combined loading state from auth and offers queries */
const isLoading: ComputedRef<boolean> = computed(() => isAuthLoading.value || isOffersLoading.value)

/** Combined error state from auth and offers queries */
const isError: ComputedRef<boolean> = computed(() => isPlusError.value || isOffersError.value)
</script>
